import { DialogContent as MuiDialogContent, withStyles } from '@material-ui/core';

const DialogContent = withStyles({
  root: { padding: 0, flex: 1 },
})(MuiDialogContent);

export default DialogContent;
